export const MAP_CONFIG = Object.freeze({
    style: 'mapbox://styles/vehi/cj6n74z660gi42rp47p30tqxu',
    pitch: 0,
    pitchWithRotate: false,
    dragRotate: false,
    minZoom: 11,
    maxZoom: 20,
});

export const MAP_ICONS = Object.freeze([
    {
        name: 'cluster-base',
        url: 'img/mapbox/cluster_focus.png',
    },
    {
        name: 'cluster-focus',
        url: 'img/mapbox/cluster_focus.png',
    },
    {
        name: 'location-base',
        url: 'img/mapbox/location_base.png',
    },
    {
        name: 'location-focus',
        url: 'img/mapbox/location_focus.png',
    },
]);

export const MAP_SOURCE_CONFIG = Object.freeze({
    type: 'geojson',
    data: {
        type: 'FeatureCollection',
    },
    cluster: true,
});

export const MAP_LAYER_CONFIG = Object.freeze([
    {
        id: 'cluster',
        type: 'symbol',
        source: 'location-data',
        filter: ['has', 'point_count'],
        layout: {
            'icon-image': 'cluster-base',
            'icon-size': 1,
            'text-field': '{point_count_abbreviated}',
            'text-size': 16,
        },
    },
    {
        id: 'location',
        type: 'symbol',
        source: 'location-data',
        filter: ['!has', 'point_count'],
        layout: {
            'icon-image': 'location-base',
            'icon-size': 1,
        },
    },
    {
        id: 'location-active',
        type: 'symbol',
        source: 'location-data',
        filter: ['all', ['!has', 'point_count'], ['==', 'name', '{name}']],
        layout: {
            'icon-image': 'location-focus',
            'icon-size': 1,
        },
    },
    {
        id: 'location-focused',
        type: 'symbol',
        source: 'location-data',
        filter: ['all', ['!has', 'point_count'], ['==', 'name', '{name}']],
        layout: {
            'icon-image': 'location-focus',
            'icon-size': 1,
        },
    },
]);



// WEBPACK FOOTER //
// ./vehi-industriepfad/assets/src/js/app/framework/components/mapbox-map/data.js